import React from 'react';

function RMCard({
  onClick,
  customStyle = null,
  customTextStyle = null,
  title,
  Icon,
  disabled = false,
}) {
  return (
    <li
      id="controls-rmcard-list"
      data-testid="controls-rmcard-list"
      className={`list-item-node node treeCommand cursor-pointer ${
        disabled && 'disabled-rmcard pointer-events-none'
      }`}
      style={{ height: 169, width: 173, ...customStyle }}
      tabIndex={1}
    >
      <div
        id="controls-rmcard-content"
        data-testid="controls-rmcard-content"
        className="list-content-node flex-column flex-y-center"
        onClick={!disabled && onClick}
      >
        <div
          id="controls-rmcard-icon-wrapper"
          data-testid="controls-rmcard-icon-wrapper"
          style={{ minWidth: '100%', height: '60%' }}
          className="flex-xy-center"
        >
          {Icon}
        </div>
        <div
          id="controls-rmcard-divider"
          data-testid="controls-rmcard-divider"
          style={{ width: '70%', background: '#bdbdbd', height: '1px' }}
        />
        <div
          id={`controls-rmcard-${title}`}
          data-testid={`controls-rmcard-${title}`}
          className="noSelectNode"
          style={customTextStyle}
        >
          {title}
        </div>
      </div>
    </li>
  );
}

export default RMCard;
